module.exports = __webpack_public_path__ + "static/media/header-background.77ea532f.png";